var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"show-big-img"},[_c('img',{attrs:{"src":_vm.src}}),_c('i',{staticClass:"el-icon-close close-icon",on:{"click":_vm.hide}})])}
var staticRenderFns = []

export { render, staticRenderFns }